import React from "react";
import type { BaseProps } from "@purpur/common-types";
import { Icon, type IconProps } from "@purpur/icon";
import c from "classnames/bind";

import { rootClassName } from "./constants";
import styles from "./footer.module.scss";

export type FooterSocialLinkProps = Omit<BaseProps<"a">, "aria-label" | "href" | "children"> & {
  "aria-label": string;
  icon: IconProps["svg"];
  href: string;
};

const cx = c.bind(styles);

export const FooterSocialLink = ({ icon, href, ...props }: FooterSocialLinkProps) => (
  <a
    {...props}
    href={href}
    className={cx(`${rootClassName}__social-link`)}
    rel="noreferrer"
    target="_blank"
  >
    <Icon svg={icon} />
  </a>
);
